module.exports = __webpack_public_path__ + "static/media/information.496024c7.svg";